import React, {useEffect, useState} from 'react';
import axios from "axios";
import {connect} from "react-redux";
import {IntlProvider} from 'react-intl';
// import en from "react-intl/locale-data/en";
import Papa from "papaparse";
import Config, {AVAILABLE_LANGUAGES, IS_LIXIL_SERVERS} from "./config";
import {baseNewImagesPath} from "./bvcomponents/assets";
import {hardCodeIsCaesarStone, hardCodeIsLowes} from "./misc/fabricatorHardcode";
import {usePrevious} from "./misc/helperHooks";
// addLocaleData([...en]);

export let TRANSLATES = {};

export const isEnglish = (locale) => {
  return (locale !== "fr-FR") && (locale !== "pl-PL") && (locale !== "es-ES")
}

const TranslatesProvider = (props) => {
  const {language, fabricatorData, children, wasCreatedFromFabricator} = props;
  const [translations, setTranslations] = useState(null);
  const [renderLanguage, setRenderLanguage] = useState(language);

  const prevLanguage = usePrevious(language);
  const prevWasCreatedFromFabricator = usePrevious(wasCreatedFromFabricator);

  const parseTranslatesResponse = (response) => {
    // handle success
    let trans = {}
    Papa.parse(response.data, {
      complete: (results) => {
        // console.log("Finished:", results.data);
        results.data[0].forEach((locale) => {
          if (locale !== "key") {
            trans[locale] = {};  // simple create an empty objects for each locale
          }
        });
        results.data.forEach((translatesArray, translatesArrayIndex) => { // vertical forEach
          if (translatesArrayIndex) { // not 0 (the first key line)
            const key = translatesArray[0]; // key, for ex. login.email
            translatesArray.forEach((translateValue, translateValueIndex) => { // horizontal forEach
              if (translateValueIndex) { // skip first key
                const locale = results.data[0][translateValueIndex]; // get first line and locale index
                trans[locale][key] = translateValue || translatesArray[1] // translate from column or english column
              }
            });
          }
        });
      }
    });
    return trans
  }

  const getCustomTranslates = (transDoc, localeString) => {
    let trans = {};
    Object.keys(transDoc)
      .filter(key => key.includes(localeString))
      .forEach(key => {
        Object.keys(transDoc[key]).forEach((sharedName) => {
          if (sharedName) {
            trans[`transDoc.${key}.${sharedName.trim()}`] = transDoc[key][sharedName]
          }
        })
      });
    return trans
  };

  const getTranslationColumn = () => {
    if (language === "en-US") {
      if (fabricatorData.isLowes) {
        return "en-US(Lowes)"
      } else if (fabricatorData.isGraniteTransformationUK) {
        return "en-GT UK Custom"
      } else if (fabricatorData.isCaesarStone) {
        console.log("fabricatorData.wasCreatedFromFabricator", fabricatorData.wasCreatedFromFabricator);
        return fabricatorData.wasCreatedFromFabricator === "QC Master Account CAN" ? "en-CAN(Caesarstone)" : "en-US(Caesarstone)"
      } else if (fabricatorData.isAmericanImport || fabricatorData.isAmericanStandard || IS_LIXIL_SERVERS) {
        return "en – Lixil"
      } else if (fabricatorData.isModerno) {
        return "en-Moderno"
      } else if (fabricatorData.isMcDermott) {
        return "en – McDermott"
      }
    } else if (language === "fr-FR" && fabricatorData.isCaesarStone) {
      return "fr-FR(Caesarstone)"
    }
    return language
  };

  const loadTranslates = async () => {
    const responseMain = await axios.get(baseNewImagesPath+'/translates/translates_v12.csv?v=1.1.1');
    const responseLookJourney = await axios.get(baseNewImagesPath+'/translates/translates_look.csv?v=1.2.3');
    const responseProductJourney = await axios.get(baseNewImagesPath+'/translates/translates_grohe.csv?v=1.1.1');
    let trans = parseTranslatesResponse(responseMain);
    let transLookJourney = parseTranslatesResponse(responseLookJourney);
    let transProductJourney = parseTranslatesResponse(responseProductJourney);
    if (hardCodeIsLowes()) {
      const responseLowes = await axios.get(baseNewImagesPath+'/translates/translates_lowes.csv?v=1.13.1')
      const doc = parseTranslatesResponse(responseLowes);
      trans["fr-FR"] = {...trans["fr-FR"], ...getCustomTranslates(doc, "_FR")};
      trans["pl-PL"] = {...trans["pl-PL"], ...getCustomTranslates(doc, "_PL")};
    } else if (hardCodeIsCaesarStone()) {
      const responseCaes = await axios.get(baseNewImagesPath + 'translates/translates_caes_v1.csv')
      const doc = parseTranslatesResponse(responseCaes);
      trans["fr-FR(Caesarstone)"] = {...trans["fr-FR(Caesarstone)"], ...getCustomTranslates(doc, "_FR")};
    }
    const responseSqft = await axios.get(baseNewImagesPath+'/translates/translates_sqft_v1.csv?ver=1.0.8');
    const transSqft = parseTranslatesResponse(responseSqft);
    for (let columnName in trans) {
      trans[columnName] = {...trans[columnName], ...transSqft[columnName]}
    }
    // delete trans["Location"];
    // delete trans["Description & Context"];
    const translationColumn = getTranslationColumn();
    TRANSLATES = {...trans[translationColumn], ...transLookJourney[language], ...transProductJourney[language]};
    setTranslations(TRANSLATES);
    if (Config.isDevMode()) {
      console.log("all translates:", trans);
      console.log("current translates:", trans[translationColumn]);
    }
    setRenderLanguage(language); // change frontend after load
  }

  useEffect(() => {
    if ((language && (prevLanguage !== language)) || (wasCreatedFromFabricator && (prevWasCreatedFromFabricator !== wasCreatedFromFabricator))) {
      if(document.kvConfig.kioskMode) {
        KioskApp.PostMessage({type: 'getTranslates'}).then(res => loadTranslates({data: res})).catch(console.error);
      } else {
        loadTranslates().catch(console.error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, wasCreatedFromFabricator])

  return translations ? (
    <IntlProvider locale={renderLanguage}
                  messages={translations}
                  defaultLocale={AVAILABLE_LANGUAGES[0]}
                  onError={(error) => console.info(error)}>
      {children}
    </IntlProvider>
  ) : null

}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState,
    wasCreatedFromFabricator: store.fabricatorState.wasCreatedFromFabricator,
    language: store.serverState.language,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TranslatesProvider)
